// ステータスが一つ以上trueかどうかを判定する関数
const existsStatusDuringSaving = statusObj =>
  Object.values(statusObj).some(status => status === true);

export default existsStatusDuringSaving;
